
    <section class="cmn-innerpage-wrapper clients">
        <div class="head">
            <div class="search-wrapper" >
                <input type="text" class="cmn-header-search" placeholder="Search" [formControl]="searchInputControl"/>
            </div>
            <button class="cmn-upload-btn" (click)="openDialog()" *ngIf="canUploadVendor$ | async">
                <img src="assets/images/icons/icon-upload.svg" alt="Upload Icon" />
                <span>Upload</span>
            </button>
            <button class="cmn-add-btn"  (click)="navigateTo('/vendors/vendors-new')" *ngIf="canAddVendor$ | async">
                <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Vendor
            </button>
        </div>
        <div class="inner-content">
            <ag-grid-angular style="width: 100%;" [rowData]="rowData" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [rowSelection]="rowSelection" [suppressRowClickSelection]="true"
                [pagination]="true" [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector" [class]="themeClass" (cellClicked)="onCellClicked($event)"/>

                <!-- <button (click)="navigateTo('/customers/client-details')">Details</button> -->
        </div>
    </section>
